'use client';

import NotFound from '@ui/components/ui/not-found';
import { useTranslations } from 'next-intl';

export default function LocaleNotFound() {
  const t = useTranslations('NotFound');

  return (
    <NotFound
      onClick={() => (window.location.href = '/auth/login')}
      text={{
        description: t('description'),
        buttonText: t('auth.button'),
      }}
    />
  );
}
